import posthog from 'posthog-js';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST;

export const isPostHogEnabled = Boolean(posthogKey && posthogHost);

if (posthogKey && posthogHost) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: '2026-08-30',
    // Only explicit trackEvent() calls and pageviews; no automatic click capture.
    autocapture: false,
    rageclick: false,
    capture_dead_clicks: false,
    capture_heatmaps: false,
    capture_performance: false,
    // Error tracking is handled by Sentry (see bootstrap/entry.tsx).
    capture_exceptions: false,
  });
} else if (import.meta.env.DEV) {
  // PostHog is production-only; outside prd the vars are intentionally absent.
  console.info('PostHog disabled: VITE_POSTHOG_KEY/HOST not set');
}

export default posthog;
